// JsFromRoutes CacheKey 22a9213d63c14a3a5cffa7d4221da74c
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@corp/services/api'

export default {
  search: /* #__PURE__ */ definePathHelper('post', '/admin/consumer/landing_pages/:landing_page_id/variants/search'),
  schedule: /* #__PURE__ */ definePathHelper('post', '/admin/consumer/landing_pages/:landing_page_id/variants/schedule'),
  index: /* #__PURE__ */ definePathHelper('get', '/admin/consumer/landing_pages/:landing_page_id/variants'),
}
